import { configureStore, Reducer } from '@reduxjs/toolkit';
import createRootSaga, { sagaMiddleware } from './rootSaga';
import { AsyncReducers, createRootReducer } from './rootReducer';
import * as Sentry from '@sentry/react';

const asyncReducers: AsyncReducers = {};

const makeReducer = () => createRootReducer(asyncReducers);

export const injectReducer = (key: keyof AsyncReducers, reducer: Reducer) => {
    if (!asyncReducers[key]) {
        asyncReducers[key] = reducer;
        store.replaceReducer(makeReducer());
    }
};

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = configureStore({
    reducer: makeReducer(),
    middleware: [sagaMiddleware],
    enhancers: (defaultEnhancers) => {
        return defaultEnhancers.concat(sentryReduxEnhancer);
    },
});

sagaMiddleware.run(createRootSaga);
